// extracted by mini-css-extract-plugin
export var divider = "_4b-0";
export var dividerText = "_4b-1";